<h2 mat-dialog-title>Uitloggen</h2>
<mat-dialog-content>Weet u zeker dat u wilt uitloggen?</mat-dialog-content>
<mat-dialog-actions>
  <button mat-flat-button color="primary" [mat-dialog-close]="false">Nee</button>
  <button mat-flat-button color="warn" [mat-dialog-close]="true">Ja</button>
</mat-dialog-actions>
